import useSmartForm from "components/request-document/hooks/useSmartForm";
import {
  SMART_S_CONDITION_TYPE_NAME_ALIAS,
  VISA_TYPE_ID,
} from "libs/configs/constant";

export default function useSmartSubName() {
  const { ConditionType, smartform } = useSmartForm();

  // console.log("useSmartSubName -> condition type ", ConditionType);
  // console.log("useSmartSubName -> smartform ", smartform.smartserviceId);

  let subName = "";

  if (smartform.smartserviceId === VISA_TYPE_ID.SMART_S) {
    subName = SMART_S_CONDITION_TYPE_NAME_ALIAS[ConditionType] || "";
  }

  if (smartform.smartserviceId === VISA_TYPE_ID.SMART_T) {
    subName = `(${ConditionType})` || "";
  }

  return subName;
}
